import {
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AbTesting } from './react/AbTesting';
import React from 'react';

import * as ReactDOM from 'react-dom/client';
import { ApiService } from '@app/core/services/api/api.service';
import { ShopService } from '@app/services/shops/shop.service';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AngularAction } from '../checkout/react/models/AngularAction';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromCheckoutReducer from '@pages/checkout-app/checkout-store/reducers/checkout.reducer';
import { CheckoutReducer } from '@pages/checkout-app/checkout-store/reducers';
import * as CheckoutActions from '@pages/checkout-app/checkout-store/actions/checkout.actions';
import { FeatureFlagService } from '@app/core/services/feature-flags/feature-flag.service';
import { FeatureFlag } from '@app/core/services/feature-flags/feature-flag.model';

@Component({
  selector: 'ab-testing-container',
  template: `@if (isLoading) {
      <div>
        <app-main-loader-lottie> </app-main-loader-lottie>
      </div>
    }
    <div #abTestingContainer></div>`,
  styleUrls: ['./ab-testing-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AbTestingContainerComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @ViewChild('abTestingContainer', { static: false }) containerRef: ElementRef;
  root: ReactDOM.Root;
  angularRoutingSubject: Subject<string> = new Subject<string>();
  angularActionSubject: Subject<AngularAction> = new Subject<AngularAction>();
  destroyed$ = new Subject();
  isLoading = true;

  constructor(
    private apiService: ApiService,
    private shopService: ShopService,
    private toastService: ToastService,
    private router: Router,
    private store: Store<fromCheckoutReducer.State>,
    private featureFlags: FeatureFlagService,
  ) {}
  ngOnInit(): void {
    // Load extension groups when ABTest tab is opened
    this.store.dispatch(CheckoutActions.loadExtensionsList());
    this.store.dispatch(CheckoutActions.loadExtensionGroups());

    this.angularRoutingSubject.pipe(takeUntil(this.destroyed$)).subscribe((url) => {
      if (url) {
        this.router.navigateByUrl(url);
      }
    });
    this.angularActionSubject.pipe(takeUntil(this.destroyed$)).subscribe((action) => {
      if (action.action === 'toast') {
        this.toastService.showToast(action.payload);

        action.callback({});
      } else if (action.action === 'show-hide-main-loader') {
        this.isLoading = action.payload.show;
        action.callback({});
      } else {
        throw Error('Unknown action');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnDestroy() {
    this.root.unmount();
  }

  private async render() {
    this.root = ReactDOM.createRoot(this.containerRef.nativeElement);
    this.root.render(
      <React.Suspense>
        <AbTesting
          angularActionSubject={this.angularActionSubject}
          angularRoutingSubject={this.angularRoutingSubject}
          shop$={this.shopService.shop$}
          extensions$={this.store.select(CheckoutReducer.selectMerchantVisibleExtensions)}
          extensionGroups$={this.store.select(CheckoutReducer.selectExtensionGroups)}
          jwtToken={this.apiService.getJwtToken}
          isFeatureFlagEnabled$={(flag: FeatureFlag) => this.featureFlags.isEnabled$(flag)}
        />
      </React.Suspense>,
    );
  }
}
